export const TN_CASE_NUMBER_INPUT_FEATURE_FLAG = "tn-case-number-input";

export function isTnCaseNumberInputEnabled(
  featureFlags?: string[] | null,
): boolean {
  return (featureFlags ?? []).includes(TN_CASE_NUMBER_INPUT_FEATURE_FLAG);
}

// YY-123456 — 2-digit year, hyphen, 6-digit sequence.
export const CASE_NUMBER_REGEX = /^\d{2}-\d{6}$/;

export function isValidCaseNumber(value: string): boolean {
  return CASE_NUMBER_REGEX.test(value);
}
